<div class="page">
  @for (element of page.elements; track element) {
    @if (element.type == 'header') {
      <h1>{{ element.value }}</h1>
    }
    @if (element.type == 'br') {
      <br />
    }
    @if (element.type == 'hr') {
      <hr />
    }
    @if (element.type == 'ul') {
      <ul>
        @for (el of element.elements; track el) {
          <li>{{ el.value }}</li>
        }
      </ul>
    }
    @if (element.type == 'p') {
      <p
        [ngClass]="controller.getClassObject(element, [])"
        >
        {{ element.value }}
      </p>
    }
    @if (element.type == 'yes-no') {
      <ng-container class="yes-no">
        <p>{{ element.value }}</p>
        <app-yes-no
          [error]="errored[element.properties.sendTo]"
          (valueChange)="handleYesNoChange($event)"
          [sendTo]="element.properties.sendTo"
        ></app-yes-no>
      </ng-container>
    }
  }

  <button
    data-testid="send-reflections-next"
    (click)="onNext()"
    class="btn btn-outline-primary btn-outline hover active"
    >
    Next
  </button>
</div>

<app-progress-bar [progressValue]="controller.getProgress()"></app-progress-bar>
